import Component from '@glimmer/component';
import { service } from '@ember/service';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import ProgramTemplateReadout from 'tio-common/components/tas/program-template-readout/readout';
import type IntlService from 'ember-intl/services/intl';
import type { TasProgramTemplateExtension as TasProgramTemplate } from 'tio-data/data/resources/tas-program-template.ext';

interface S {
  Args: {
    model: TasProgramTemplate;
  };
}

/**
 * The employer-admin view of a program template. The read-out is strictly read-only: this app
 * ships no builder route, no edit affordance, and nothing that writes a template.
 */
export default class AdminProgramTemplatesShow extends Component<S> {
  @service declare intl: IntlService;

  get title() {
    return (
      String(this.args.model.programName || '').trim() ||
      this.intl.t('program_builder.readout.untitled_program')
    );
  }

  get subtitle() {
    const code = this.args.model.code;
    return code ? this.intl.t('program_builder.readout.program_code', { code }) : undefined;
  }

  <template>
    <VStack>
      <PageHeader @title={{this.title}} @subtitle={{this.subtitle}} @sticky={{false}} />
      <ProgramTemplateReadout @model={{@model}} />
    </VStack>
  </template>
}
